const privacyCheck = document.getElementById('privacyCheck');
const entryBtn = document.getElementById('entryBtn');

if (privacyCheck) {
  privacyCheck.addEventListener('click', function () {
    //console.log(this.checked);
    if (this.checked) {
      entryBtn.disabled = false;
    } else {
      entryBtn.disabled = true;
    }
  });

  window.addEventListener('load', function () {
    privacyCheck.checked = false;
  });
}
